import { useUserAuthState } from '@cosuno/authentication-frontend';
import { authFor, useAuth } from '@cosuno/authorization-frontend';
import { PageLoader } from '@cosuno/cosuno-ui';
import React, { type PropsWithChildren, useMemo } from 'react';

import Navbar from '~/shared/components/Navbar';
import { scrollContainerId } from '~/shared/constants';

import * as Styled from './Styles';

type Props = PropsWithChildren<{ renderLayout?: boolean }>;

const AppPage: React.FC<Props> = ({ children, renderLayout }) => {
  const { companyType, currentUser, isUserAuthenticated } = useUserAuthState();

  const {
    results: { canViewSubcontractors },
    loading: loadingAuth,
  } = useAuth({
    canViewSubcontractors:
      currentUser &&
      authFor('Company').canI('view__subcontractors').where({ id: currentUser.company.id }),
  });

  return (
    <>
      <Styled.Main>
        {useMemo(
          () =>
            isUserAuthenticated &&
            renderLayout &&
            companyType && (
              <Navbar companyType={companyType} canViewSubcontractors={canViewSubcontractors} />
            ),
          [canViewSubcontractors, companyType, isUserAuthenticated, renderLayout],
        )}
        <Styled.MainContentWrapper id={scrollContainerId}>{children}</Styled.MainContentWrapper>
      </Styled.Main>
      {currentUser && loadingAuth && (
        <Styled.PageLoaderOverlay>
          <PageLoader />
        </Styled.PageLoaderOverlay>
      )}
    </>
  );
};

export default AppPage;
